/* eslint-disable import/default */
import "babel-polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { initThemeColors } from "./theme/colors";
import DialogProvider from "components/Shared/DialogProvider.tsx";
import WebConfig from "./middlewares/WebConfig";
import { PhoenixFormsProvider } from "components/PhoenixFormsV4/index.tsx";
import QuickFilterProvider from "components/QuickLists/QuickFilterProvider.tsx";

// Initialize theme colors (injects CSS custom properties)
// This must run before render to ensure colors are available
initThemeColors();

// CSS and other assets
require("./favicon.ico"); // Tell webpack to load favicon.ico
import "mueller-controls/dist/src/mueller-controls.css";
import "styles/styles.scss";
if (WebConfig.rootStylesheet) {
  //This switch layer is required to proxy the values in the webconfig as import paths can not be a variable or the result of string interpolation
  switch (WebConfig.rootStylesheet) {
    case ("./environment/non-prod-styles.scss"): {
      import("./environment/non-prod-styles.scss");
    }
  }
}

// local components
import App from "containers/App";
import configureStore from "store/configureStore";
import BrowserWarning from "components/Shared/BrowserWarning";
import CacheBuster from "components/Shared/CacheBuster";
import AppInsightsInit from "middlewares/AppInsightsInit";
import TooltipProvider from "components/Shared/TooltipProvider.tsx";
import MuellerThemeProvider from "components/Shared/MuellerThemeProvider.tsx";
import SpacingProvider from "components/Shared/SpacingProvider.tsx";
import WindowProvider from "components/Shared/WindowProvider.tsx";
AppInsightsInit.init();

// React Router 7 manages its own history, so we no longer create one here
const { persistor, store } = configureStore();

// exporting store to allow access to dispatch and state from outside a react component
// must export store before rendering, some parts of the system make web calls instantly when render is called, and then store isnt exported yet
export default store;

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <div>
    <BrowserWarning />
    <Provider store={store}>
      <MuellerThemeProvider>
        <SpacingProvider>
          <ThemeProvider {...{ theme }}>
            <WindowProvider>
            <DialogProvider>
              <TooltipProvider>
                <PhoenixFormsProvider>
                  <QuickFilterProvider>
                    <CacheBuster/>
                    <App persistor={persistor} />
                  </QuickFilterProvider>
                </PhoenixFormsProvider>
              </TooltipProvider>
            </DialogProvider>
            </WindowProvider>
          </ThemeProvider>
        </SpacingProvider>
      </MuellerThemeProvider>
    </Provider>
  </div>
);
